import { Setting, SettingDisplay } from "../Common/Settings";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../../format";
import { i18n } from "../../../i18n";

export default function InvoiceDateSet({ value }) {
  const { t } = useTranslation(["common", "settings"]);
  const label = t("settings:items.subscription.billingDate");

  return (
    <Setting>
      <SettingDisplay
        label={label}
        value={value ? formatDate(value, i18n.resolvedLanguage) : value}
      />
    </Setting>
  );
}
